import { render } from "./vue-horizontal.vue?vue&type=template&id=33122f23&ts=true"
import script from "./vue-horizontal.vue?vue&type=script&lang=ts"
export * from "./vue-horizontal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Visual Studio\\Projects\\Web\\GGDev.Web.ThePortal\\GGDev.Web.ThePortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__